import { render, staticRenderFns } from "./FacilityOverview.vue?vue&type=template&id=3d5a2e28&scoped=true"
import script from "./FacilityOverview.vue?vue&type=script&lang=js"
export * from "./FacilityOverview.vue?vue&type=script&lang=js"
import style0 from "./FacilityOverview.vue?vue&type=style&index=0&id=3d5a2e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5a2e28",
  null
  
)

export default component.exports